import type { ReactNode } from "react";
import React from "react";
import cx from "classnames";
import { useVerticalTabsStyles } from "./useVerticalTabsStyles";

export const VerticalTabsContainer = ({
    children,
    className: originalClassName,
}: {
    children: ReactNode;
    className?: string;
}) => {
    const classes = useVerticalTabsStyles();
    const className = cx(classes.tabsContainerRoot, originalClassName);

    return <div className={className}>{children}</div>;
};
